import { Injectable, inject } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { map, catchError, finalize } from "rxjs/operators";
import { ErrorDialogService } from "@core/components/error-dialog/errordialog.service";
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse, } from "@angular/common/http";
import { firstMayusPipe } from "@core/pipes/utils-pipe";

@Injectable()
export class HttpManageErrorInterceptor implements HttpInterceptor {
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    public errorDialogService: ErrorDialogService,

  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const wsName: string = request.url.split("/").pop();
    
    return next.handle(request).pipe(
      finalize(() => {

      }),
      map((response: HttpEvent<any>) => {

        let loadOpenModalCloseSesion = () => {
          let dataErrorConect = { codeError: 419, wsName: wsName };
          this.errorDialogService.openModalErr(dataErrorConect);
        }, loadModalErr409 = (message) => {
          let dataError409 = { codeError: 409, wsName: wsName, message: message };
          this.errorDialogService.openModalErr(dataError409);
        }, _firstMayus = (input: any) => {
          let first = (typeof input == 'string') ? input.substr(0, 1).toUpperCase() : '';
          return (typeof input == 'string') ? first + input.substr(1).toLowerCase() : input;
        };

        if (response instanceof HttpResponse) {

          let bodyResponse = response?.body,
            dataBody = bodyResponse?.data;

          if (bodyResponse?.numeroError && bodyResponse?.numeroError != 0) {
            let txtError = bodyResponse?.mensajeError;
            loadModalErr409(_firstMayus(txtError?.trim()))
          }

        }

        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      })
    );
  }
}
